let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4dn8m")).then(() => parcelRequire('khkEv'));